import React, { useState, useEffect } from 'react'
import Session from "react-session-api";
import axios from "axios";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import ReturnClass from "../Login/ReturnClassToken";
import { useNavigate } from "react-router-dom";
import BindControlsValues from "../Dashboard/BindControls";

function Dashboard() {

    //window.location.reload();

    const apiurl = window.SERVICE_URL;

    const navigate = useNavigate();
    if (localStorage.getItem("loginsession") != null) {
        const res = JSON.parse(localStorage.getItem("loginsession"));
        ReturnClass.EmailID = res.EmailID;
        ReturnClass.MobileNumber = res.MobileNumber;
        ReturnClass.AccessToken = res.AccessToken;
        ReturnClass.UserID = res.UserID;
        ReturnClass.PartnerID = res.PartnerID;
        //var uid = res.UserID;

    }
    else {
        navigate("/");
    }

    //modal 1
    const [show, setShow] = useState(false);
    const handleClose = () => { setShow(false); }
    const handleShow = () => setShow(true);

    //modal 2
    const [show2, setShow2] = useState(false);
    const handle2Close = () => { setShow2(false); }
    const handle2Show = () => setShow2(true);

    //model 3
    const [show3, setShow3] = useState(false);
    const handle3Close = () => { setShow3(false); }
    const handle3Show = () => setShow3(true);

    const [data, dataSet] = useState([]);
    useEffect(() => {
        getData();
    }, [dataSet]);


    async function getData() {
       
        await axios.get(apiurl + `api/VerifyPartnerPendingoptions?partnerId=` + ReturnClass.PartnerID,
            {
                headers: {
                    "Authorization": `Bearer ${ReturnClass.AccessToken}`
                }
            }).then(function (response) {
               
                dataSet(response.data);
                if (response.data.noOfDaysLeft >= 10) {

                    if (response.data.pendingVerfication == 1) {
                        BindControlsValues.BindEmailID = "";
                        BindControlsValues.BindMobile = response.data.mobileNumber;
                        BindControlsValues.OTPFor = 1;
                        BindControlsValues.IsMobileVerification = { display: 'block' };
                        setShow3(true)
                    }

                    else if (response.data.pendingVerfication == 2) {
                        //Email Verifcation Pending show Popup with Block All menu
                        BindControlsValues.BindEmailID = response.data.emailID;
                        BindControlsValues.BindMobile = "";
                        BindControlsValues.OTPFor = 2;
                        BindControlsValues.IsEmailVerification = { display: 'block' };
                        setShow3(true)
                    }
                }
                else {
                    if (response.data.pendingVerfication == 1) {
                        //Mobile Verifcation Pending show Popup with Block All menu
                        BindControlsValues.BindEmailID = "";
                        BindControlsValues.BindMobile = response.data.mobileNumber;
                        BindControlsValues.OTPFor = 1;
                        BindControlsValues.IsMobileVerification = { display: 'block' };
                        setShow(true)
                    }
                    else if (response.data.pendingVerfication == 2) {
                        //Email Verifcation Pending show Popup with Block All menu
                        BindControlsValues.BindEmailID = response.data.emailID;
                        BindControlsValues.BindMobile = "";
                        BindControlsValues.OTPFor = 2;
                        BindControlsValues.IsEmailVerification = { display: 'block' };
                        setShow(true)
                    }
                }
            })
            .catch(error => {
                console.log(error.response)
            });
    }

    const afterloginotpsend = {
        PartnerID: ReturnClass.PartnerID,
        OTPMobile: "",
        OTPEmail: "",
        AddedOn: new Date(),
        IsUsed: false,
        VerifiedOn: new Date(),
        OTPFor: BindControlsValues.OTPFor,
        UserID: ReturnClass.UserID,
        VerifyOTPFor: 1,
        MobileNo: BindControlsValues.BindMobile,
        EmailID: BindControlsValues.BindEmailID,
    }

    const otpsend = async (e) => {
        e.preventDefault();
      
        await axios.post(apiurl + `api/SendOTPAfterLogin`, afterloginotpsend, {
            headers: {
                "Authorization": `Bearer ${ReturnClass.AccessToken}`,
                "Content-Type": "application/json",
            },
        })
            .then((result) => {
                
                if (result.data.outMessage == "OTP Saved Successfully and Sent on Your Select Option Please Verify your OTP..") {
                    setShow(false);
                    setShow2(true);
                }
            });
    };

    const verifyOTPUser = async (e) => {
        e.preventDefault();
        var IsMobile = document.getElementById("txtMobile").value;
        var Isemail = document.getElementById('txtEmail').value;
        const sendOTPClass = {
            PartnerID: ReturnClass.PartnerID,
            OTPMobile: IsMobile,
            OTPEmail: Isemail,
            AddedOn: new Date(),
            IsUsed: false,
            VerifiedOn: new Date(),
            OTPFor: BindControlsValues.OTPFor,
            UserID: ReturnClass.UserID,
            VerifyOTPFor: 1,
            MobileNo: "",//returnclass.MobileNumber,
            EmailID: ""//returnclass.EmailID
        }
        await axios.post(apiurl + `api/VerifyOTPAfterLogin`, sendOTPClass, {
            headers: {
                "Authorization": `Bearer ${ReturnClass.AccessToken}`,
                'Content-Type': 'application/json',
            }
        })
            .then((result) => {
                debugger;
                if (result.data.pendingVerfication == 4) {
                    setShow(false);
                    setShow2(false);
                }
                else {
                    setShow2(true);
                }
            })

    }


    const LoginPending = async (e) => {
        e.preventDefault();
            navigate("/");
        }

    return (
        <>
            <div className="alert alert-light d-flex align-items-center mb-3 px-4">
                <h5
                    className="yoc-subheader__title text-uppercase mb-0 pl-md-2"
                    style={{ fontSize: "14px" }}>
                    Home
                </h5>
                <span className="seperator-danger ml-lg-3 ml-md-3 ml-sm-3 ml-2 mr-2 text-danger"></span>
                <span className="text-danger font-weight-500 f13">Dashbaord</span>
            </div>

            <h1>Dashboard</h1>
            <h1>Uploadquestion</h1>
            <p>In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content. Lorem ipsum may be used as a placeholder before final copy is available.In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content. Lorem ipsum may be used as a placeholder before final copy is available.In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content. Lorem ipsum may be used as a placeholder before final copy is available.In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content. Lorem ipsum may be used as a placeholder before final copy is available.In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content. Lorem ipsum may be used as a placeholder before final copy is available.In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content. Lorem ipsum may be used as a placeholder before final copy is available.In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content. Lorem ipsum may be used as a placeholder before final copy is available.</p>

            <div>
                <p>if Your Want to Verify Pending Options Than </p>
                <button type="button" onClick={handleClose}>click here</button>
            </div>

            <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false} >
                <form className="yoc-form yoc-form--fit yoc-form--label-right">
                    <Modal.Header>
                        <Modal.Title>Send Pending OTP</Modal.Title>
                        <Button onClick={handleClose}>X</Button>
                    </Modal.Header>

                    <Modal.Body>
                        <div className="form-group row yoc-margin-t-10" style={BindControlsValues.IsMobileVerification}>
                            <div className="col-md-12">
                                <input type="text" id="txtMobile" value={BindControlsValues.BindMobile} className="form-control" placeholder="Mobile" name="Mobile" />
                            </div>
                        </div>
                        <div className="form-group row yoc-margin-t-10" style={BindControlsValues.IsEmailVerification}>
                            <div className="col-md-12">
                                <input type="text" id="txtEmail" value={BindControlsValues.BindEmailID} className="form-control" placeholder="Email" name="Email" />
                            </div>
                        </div>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="primary" onClick={otpsend}>
                            Send OTP
                        </Button>
                        <Button variant="secondary" onClick={handleClose}>
                            Cancel
                        </Button>
                    </Modal.Footer>
                </form>
            </Modal>

            <Modal show={show2} onHide={handle2Close} backdrop="static" keyboard={false} >
                <form className="yoc-form yoc-form--fit yoc-form--label-right">
                    <Modal.Header>
                        <Modal.Title>Verify Pending OTP</Modal.Title>
                        <Button onClick={LoginPending}>X</Button>
                    </Modal.Header>

                    <Modal.Body>
                        <div className="form-group row yoc-margin-t-10" style={BindControlsValues.IsMobileVerification}>
                            <div className="col-md-12">
                                <input type="text" id="txtMobile" className="form-control" placeholder="Enter Mobile OTP" name="Mobile" />
                            </div>
                        </div>
                        <div className="form-group row yoc-margin-t-10" style={BindControlsValues.IsEmailVerification}>
                            <div className="col-md-12">
                                <input type="text" id="txtEmail" className="form-control" placeholder="Enter Email OTP" name="Email" />
                            </div>
                        </div>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="primary" onClick={verifyOTPUser}>
                            Send OTP
                        </Button>
                        <Button variant="secondary" onClick={handle2Close}>
                            Cancel
                        </Button>
                    </Modal.Footer>
                </form>
            </Modal>

            <Modal show={show3} onHide={handle3Close} backdrop="static" keyboard={false} >
                <form className="yoc-form yoc-form--fit yoc-form--label-right">
                    <Modal.Header>
                        <Modal.Title>Verify Pending OTP</Modal.Title>
                        <Button onClick={LoginPending}>X</Button>
                    </Modal.Header>

                    <Modal.Body>
                        <div className="form-group row yoc-margin-t-10" style={BindControlsValues.IsMobileVerification}>
                            <div className="col-md-12">
                                <input type="text" id="txtMobile" value={BindControlsValues.BindMobile} className="form-control" placeholder="Mobile" name="Mobile" />
                            </div>
                        </div>
                        <div className="form-group row yoc-margin-t-10" style={BindControlsValues.IsEmailVerification}>
                            <div className="col-md-12">
                                <input type="text" id="txtEmail" value={BindControlsValues.BindEmailID} className="form-control" placeholder="Email" name="Email" />
                            </div>
                        </div>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="primary" onClick={otpsend}>
                            Send OTP
                        </Button>
                        <Button variant="secondary" onClick={LoginPending}>
                            Cancel
                        </Button>
                    </Modal.Footer>
                </form>
            </Modal>

        </>
    );
};

export default Dashboard;
